import { createSelector } from 'reselect'
import { RootState } from '~/store'

import { RequestError } from '~/common/define/requestError'

export const GetError = createSelector(
  [(state: RootState) => state.error.requestError],
  (requestError: RequestError) => requestError
)